import { ACTION } from './heat_pump_actions';

const initialState = {
  items: {},
  orderedIds: [],
  totalCount: null,
  filteredCount: null,
  isLoading: false,
  isCreating: false,
  isEditing: false,
  isDeleting: false,
  isDuplicating: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        items: action.payload.data.reduce((items, item) => ({...items, [item.id]: item}), {}),
        orderedIds: action.payload.data.map(item => item.id),
        totalCount: action.payload.recordsTotal,
        filteredCount: action.payload.recordsFiltered,
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        items: {
          ...state.items,
          [action.payload.id]: action.payload,
        },
        orderedIds: [
          action.payload.id,
          ...state.orderedIds,
        ],
        isCreating: false,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        isEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        items: {
          ...state.items,
          [action.payload.id]: action.payload,
        },
        isEditing: false,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        items: (() => {
          let clonedItems = { ...state.items };
          delete clonedItems[action.payload.id];
          return clonedItems;
        })(),
        orderedIds: state.orderedIds.filter(id => id !== action.payload.id),
        isDeleting: false,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DUPLICATE}_PENDING`:
      return {
        ...state,
        isDuplicating: true,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_FULFILLED`:
      return {
        ...state,
        items: {
          ...state.items,
          [action.payload.id]: action.payload,
        },
        orderedIds: [
          action.payload.id,
          ...state.orderedIds,
        ],
        isDuplicating: false,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_REJECTED`:
      return {
        ...state,
        isDuplicating: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/heat_pump/heat_pump_reducers.js